import script from "./SliderEventos.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderEventos.vue?vue&type=script&setup=true&lang=js"

import "./SliderEventos.vue?vue&type=style&index=0&id=3c6769be&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c6769be"]])

export default __exports__